import { css } from "@linaria/core";

export const container = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const searchRow = css`
  flex: 0 0 auto;
  padding: var(--ant-padding);
  border-bottom: 1px solid var(--ant-color-border-secondary);
  display: flex;
  flex-direction: column;
  gap: var(--ant-margin-sm);
`;

export const splitArea = css`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: row;
`;

export const leftPane = css`
  flex: 1 1 60%;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  padding: var(--ant-padding);
`;

export const rightPane = css`
  flex: 1 1 40%;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  padding: var(--ant-padding);
  border-left: 1px solid var(--ant-color-border-secondary);
`;

export const footerRow = css`
  flex: 0 0 auto;
  padding: var(--ant-padding-sm) var(--ant-padding);
  border-top: 1px solid var(--ant-color-border-secondary);
  display: flex;
  justify-content: flex-end;
`;

export const chevronCell = css`
  color: var(--ant-color-text-tertiary);
  text-align: right;
`;
